import * as Immutable from "immutable";
import { Decoration } from "./decoration";

export class DocumentsDecoration extends Decoration {

}